import proj4 from 'proj4';

import coordinateSystems from '../../../static/projections/spatialreference.yaml';

const coordinateSystemsRecord = coordinateSystems as Record<string, string>;

/**
 * Returns the actual proj4 definition string for the given projection.
 *
 * For example passing 'local' will return:
 * +proj=tmerc +k_0=0 +lon_0=0 +lat_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m
 *
 * If the alias doesnt exist then it means the original string is already a proj4 definition.
 */
export function getProj4Definition(aliasOrProj4Definition: string): string {
  return coordinateSystemsRecord[aliasOrProj4Definition] ?? aliasOrProj4Definition;
}

/**
 *  Defines the projections currently used by the application in proj4.
 *  Allows to reference projection by name instead of proj4 definitions.
 *
 *  See ´spatialreference.yaml´ for differences
 */
export const defineProj4Projections = () => {
  for (const projection of Object.keys(coordinateSystemsRecord)) {
    proj4.defs(projection, coordinateSystemsRecord[projection]);
  }
};
